import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LecturesComponent} from './lectures/lectures.component';
import {RecordsComponent} from './records.component';
import {SeriesComponent} from './series/series.component';
import {SermonsComponent} from './sermons/sermons.component';

const routes: Routes = [
    {
        path: 'felvetelek',
        children: [
            {path: '', component: RecordsComponent},
            {path: 'tanitasok', component: SermonsComponent},
            {path: 'sorozatok', component: SeriesComponent},
            {path: 'sorozatok/:id', component: LecturesComponent},
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SermonsRoutingModule {}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/sermons-routing.module.ts